import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/LogoutButton/logoutButton.container"
    ).then((module) => ({
        default: module.LogoutButtonContainer
    }))
);
